import React from 'react';
import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

import Wrapper from '../LandingBlockWrapper/BlockWrapper';


export default () => (
	<Wrapper className='FreshMint'>
		<Row>
			<Col xs={24} sm={24} md={{ span: 8, offset: 1 }}>
				<h2><FormattedMessage {...messages.titleMeet} /></h2>
				<h3><FormattedMessage {...messages.subtitleMeet} /></h3>
			</Col>
			<Col xs={24} sm={24} md={{ span: 12, offset: 1 }}>
				<p><FormattedMessage {...messages.titleDefine} /></p>
				<p><FormattedMessage {...messages.subtitleDefine} /></p>
			</Col>
		</Row>
	</Wrapper>
);


// WEBPACK FOOTER //
// ./src/components/LandingFreshMint/FreshMint.js